<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Reporte resumen entregas</v-toolbar-title
          >
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1 pre-formatted"
            :pagination.sync="miPaginacion"
            hide-actions
          >
            <template v-slot:items="props">
              <tr>
                <td v-for="c in parseInt(columnas)" class="text-xs-center">
                  {{ props.item[c - 1] }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <!-- descarga informe -->
      <v-dialog v-model="loadingInforme" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          v-if="botonDescarga == true"
          color="primary"
          @click="descargaInforme()"
        >
          Descarga informe
          <v-icon right dark>folder</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </v-container>
</template>

<style>
.pre-formatted {
  white-space: pre;
}
table.v-table thead th {
  white-space: pre;
}
</style>
<script>
import GridRecepcion from "./GridRecepcion.vue";

import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "recepcionCap-sub-tab",

  components: {
    GridRecepcion,
    Loading,
    LoadingDescarga,
    AlertEmpty,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
  },
  data() {
    return {
      idContrato: "",
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      recepcionGrid: 0,
      items: [],
      datos: "",
      loading: false,
      alerta: false,
      botonDescarga: false,
      loadingInforme: "",
      headers: [],
      columnas: 0,
    };
  },

  watch: {
    datos(val) {
      this.columnas = this.datos.headers.length + 1;

      if (this.datos && this.datos.headers && this.datos.headers.length > 0) {
        this.headers.push({
          text: "Fecha Recepción",
          value: "Fecha Recepción",
          sortable: false,
        });

        var i = 0;
        this.datos.headers.forEach((titulo) => {
          this.headers.push({
            text: titulo + "\n" + this.datos.headersTipo[i],
            value: titulo + "aaa" + this.datos.headersTipo[i++],
            sortable: false,
            align: "center",
          });
        });
      }
    },
  },
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },

  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.datos = await this.loadReporteEntregas();
      this.botonDescarga = false;
      this.items = this.datos.data;
      this.miPaginacion.totalItems = this.items.length;

      if (this.items.length > 0) {
        this.alerta = false;
        this.botonDescarga = true;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    async loadReporteEntregas() {
      return await axios
        .get("/capturaRecepcion/reporteEntregas/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async descargaInforme() {
      this.loadingDescarga = true;
      // var nombreArchivo = "INFORME_" + this.producto.descripcion.replaceAll(/[^a-zA-Z0-9-]+/, "_") + ".xlsx";

      return await axios
        .get("/capturaRecepcion/descargaReporteEntregas/" + this.idContrato, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;

          link.setAttribute("download", "Resumen_detalle_entregas.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          if (error) {
            window.getApp.$emit(
              "ERROR_EXCEPTION",
              "Ha ocurrido un error al generar la descarga"
            );
          }
        });
    },
  },
};
</script>
